import _typeof from "@babel/runtime/helpers/typeof";
import Handlebars from '@sparta.global.vendors/handlebars';
var helperNamespace = 'spartaContentManagerHelper';

/**
   * @method helpers.spartaContentManagerHelper
   * @param {object} context JSON object used to build the cms group.
   * @returns {Node} `Handlebars.SafeString`.
   */
function spartaContentManagerHelper(config) {
  if (config && _typeof(config) === 'object' && config.contentKey) {
    // Settings from provided JCR
    var id = config.id;
    var _config$tagWrapper = config.tagWrapper,
      tagWrapper = _config$tagWrapper === void 0 ? 'div' : _config$tagWrapper;
    var _config$classList = config.classList,
      classList = _config$classList === void 0 ? '' : _config$classList;
    var _config$ariaLive = config.ariaLive,
      ariaLive = _config$ariaLive === void 0 ? 'off' : _config$ariaLive;
    var key = config.contentKey;
    var record = config.contentRecord;
    var idAttr = id ? "id=\"".concat(id, "\"") : '';
    var ariaLiveAttr = typeof ariaLive === 'string' ? "aria-live=\"".concat(ariaLive, "\"") : '';

    // Define how record (if available) is parsed
    var recordAttr = '';
    if (record && typeof record === 'string') {
      recordAttr = "data-content-record-key=\"".concat(record, "\"");
    } else if (record && _typeof(record) === 'object') {
      recordAttr = "data-content-record-key=\"".concat(Handlebars.Utils.escapeExpression(JSON.stringify(record)), "\"");
    }

    // Data options object
    // Used for some custom settings within utility
    var optionsAttr = config.options ? "data-options=\"".concat(Handlebars.Utils.escapeExpression(JSON.stringify(config.options)), "\"") : '';

    // Data dynamic tokens object
    // Key/value replacement object for returned record
    var dynamicDataAttr = config.dynamicTokens ? "data-dynamic-tokens=\"".concat(Handlebars.Utils.escapeExpression(JSON.stringify(config.dynamicTokens)), "\"") : '';

    // Determine if auto inject feature is enabled
    // Used when components may use a key/record lookup and then use the response in a different method (footnotes) but not to the original target element.
    var disableAutoInject = config.options && config.options.autoInject && config.options.autoInject.toString() === 'false' ? 'data-content-inject="false"' : '';

    // Create a list of attributes for the cms wrapper
    var _config$attributes = config.attributes,
      attributes = _config$attributes === void 0 ? {} : _config$attributes;
    var attributesString = '';
    Object.keys(attributes).forEach(function (key) {
      if (typeof attributes[key] === 'string' || typeof attributes[key] === 'boolean') {
        attributesString += "".concat(key, "=\"").concat(attributes[key], "\"");
      } else {
        attributesString += "".concat(key, "=\"").concat(Handlebars.Utils.escapeExpression(JSON.stringify(attributes[key])), "\"");
      }
    });

    // Write DOM element
    var output = "\n      <".concat(tagWrapper, "\n        ").concat(idAttr, "\n        class=\"spa-cms-wrapper ").concat(classList, "\"\n        data-content-key=\"").concat(key, "\"\n        ").concat(disableAutoInject, "\n        ").concat(recordAttr, "\n        ").concat(ariaLiveAttr, "\n        ").concat(optionsAttr, "\n        ").concat(dynamicDataAttr, "\n        ").concat(attributesString, "\n      ></").concat(tagWrapper, ">\n    ");

    // Return HTML to page.
    return new Handlebars.SafeString("".concat(output.replace(/[\t\n\r]/gm, '')));
  } else {
    console.warn("Invalid JCR setup for ".concat(helperNamespace), config);
    return '';
  }
}
export { spartaContentManagerHelper };